export interface EnvironmentConfig {
    graphServiceUrl: string;
    integrationServiceUrl: string;
    webhookServiceUrl: string;
    liveSyncServiceUrl: string;
    collabServiceUrl: string;
    aiServiceUrl: string;
    agentServiceUrl: string;
    formsServiceUrl: string;
}

const stageEnvironmentVariableMissingMessage =
    'Glue is missing the stage environment variable, please specify the environment variable VITE_APP_GLUE_STAGE.\nexample: VITE_APP_GLUE_STAGE=development';

export const getEnvironmentConfig = (): EnvironmentConfig => {
    const stage = import.meta.env.VITE_APP_GLUE_STAGE;
    if (!stage) {
        throw new Error(stageEnvironmentVariableMissingMessage);
    }

    switch (stage) {
        case 'local': {
            // Local Docker development environment
            const apiUrl = 'http://localhost:6104';
            return {
                graphServiceUrl: `${apiUrl}/api`,
                integrationServiceUrl: `${apiUrl}/api`,
                webhookServiceUrl: `${apiUrl}/api`,
                liveSyncServiceUrl: 'ws://localhost:6105',
                collabServiceUrl: 'ws://localhost:6107',
                aiServiceUrl: `${apiUrl}/api`,
                agentServiceUrl: 'ws://localhost:6104/ws/agent',
                formsServiceUrl: 'http://localhost:6106',
            };
        }
        case 'railway-production': {
            const apiUrl = 'https://api.glueapp.org';
            return {
                graphServiceUrl: `${apiUrl}/api`,
                integrationServiceUrl: `${apiUrl}/api`,
                webhookServiceUrl: `${apiUrl}/api`,
                liveSyncServiceUrl: 'wss://worker.glueapp.org',
                collabServiceUrl: 'wss://collab.glueapp.org',
                aiServiceUrl: `${apiUrl}/api`,
                agentServiceUrl: 'wss://api.glueapp.org/ws/agent',
                formsServiceUrl: 'https://forms.glueapp.org',
            };
        }
        case 'railway-development': {
            const apiUrl = 'https://api.development.glueapp.org';
            return {
                graphServiceUrl: `${apiUrl}/api`,
                integrationServiceUrl: `${apiUrl}/api`,
                webhookServiceUrl: `${apiUrl}/api`,
                liveSyncServiceUrl: 'wss://worker.development.glueapp.org',
                collabServiceUrl: 'wss://collab.development.glueapp.org',
                aiServiceUrl: `${apiUrl}/api`,
                agentServiceUrl: 'wss://api.development.glueapp.org/ws/agent',
                formsServiceUrl: 'https://forms.development.glueapp.org',
            };
        }
        default: {
            // For unrecognized stages, fall back to railway-development pattern
            const apiUrl = 'https://api.development.glueapp.org';
            return {
                graphServiceUrl: `${apiUrl}/api`,
                integrationServiceUrl: `${apiUrl}/api`,
                webhookServiceUrl: `${apiUrl}/api`,
                liveSyncServiceUrl: 'wss://worker.development.glueapp.org',
                collabServiceUrl: 'wss://collab.development.glueapp.org',
                aiServiceUrl: `${apiUrl}/api`,
                agentServiceUrl: 'wss://api.development.glueapp.org/ws/agent',
                formsServiceUrl: 'https://forms.development.glueapp.org',
            };
        }
    }
};
